import React, { useEffect, useRef, useState } from "react";
import { MapPin } from "@phosphor-icons/react";
import { geocode } from "@/lib/geo";

export function AddressInput({ label, token, proximity, value, onSelect, testid }) {
  const [q, setQ] = useState(value?.address || "");
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);
  const t = useRef();
  useEffect(() => { setQ(value?.address || ""); }, [value]);
  const onChange = (e) => {
    const v = e.target.value;
    setQ(v);
    clearTimeout(t.current);
    if (v.trim().length < 3) { setOpts([]); setOpen(false); return; }
    t.current = setTimeout(async () => {
      try { const res = await geocode(v, token, proximity); setOpts(res); setOpen(true); } catch {}
    }, 300);
  };
  return (
    <div className="relative">
      {label && <label className="text-xs font-medium text-muted-foreground">{label}</label>}
      <input data-testid={testid} value={q} onChange={onChange} onFocus={() => opts.length && setOpen(true)}
        placeholder="Search address…"
        className="mt-1 w-full rounded-xl border border-border bg-card px-3 py-2.5 text-sm outline-none focus:border-primary" />
      {open && opts.length > 0 && (
        <div className="absolute z-30 mt-1 w-full overflow-hidden rounded-xl border border-border bg-card shadow-xl">
          {opts.map((o, i) => (
            <button key={i} data-testid={`${testid}-opt-${i}`}
              onClick={() => { onSelect(o); setQ(o.address); setOpen(false); }}
              className="flex w-full items-start gap-2 border-b border-border/50 px-3 py-2 text-left text-sm last:border-0 hover:bg-secondary">
              <MapPin size={15} className="mt-0.5 shrink-0 text-primary" weight="fill" />
              <span className="line-clamp-2">{o.address}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
